import { render, staticRenderFns } from "./ItemMapPopup.vue?vue&type=template&id=15fec56f&scoped=true"
import script from "./ItemMapPopup.vue?vue&type=script&lang=js"
export * from "./ItemMapPopup.vue?vue&type=script&lang=js"
import style0 from "./ItemMapPopup.vue?vue&type=style&index=0&id=15fec56f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fec56f",
  null
  
)

export default component.exports